import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { getCurrentMonthStartDate } from 'utils/dateUtil';

const leaveSlice = createSlice({
  name: 'leave',
  initialState: {
    rows: [],
    dashboardRows: [],
    filter: {
        startDate: dayjs(getCurrentMonthStartDate()),
        endDate: dayjs(new Date())
    }
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
    replaceDashboardData(state, action) {
      state.dashboardRows = action.payload;
    },
    replaceFilter(state, action) {
      state.filter.startDate = action.payload.startDate;
      state.filter.endDate = action.payload.endDate
    },
  },
});

export const leaveActions = leaveSlice.actions;

export default leaveSlice;